import { fetchApi } from "../../../helpers/fetch";

const GOOGLE_AUTH_ERROR_MESSAGES = {
  GOOGLE_AUTH_CODE_MISSING: "Google sign-in could not start because the auth code is missing.",
  GOOGLE_AUTH_EXCHANGE_FAILED: "Google sign-in failed while validating your account. Please try again.",
  GOOGLE_PROFILE_EMAIL_MISSING: "Your Google account does not expose an email address. Please use another account.",
  PROFILE_LOOKUP_FAILED: "We could not load your HYK profile. Please try again.",
  PROFILE_BOOTSTRAP_FAILED: "We could not finish your account setup. Please try again.",
  GOOGLE_AUTH_CALLBACK_FAILED: "Google sign-in did not complete. Please try again.",
  GOOGLE_AUTH_START_FAILED: "Unable to start Google sign-in right now. Please try again.",
  GOOGLE_AUTH_INVALID_PAYLOAD: "Google sign-in returned an invalid response. Please try again.",
};

export const getGoogleAuthErrorMessage = (code, fallbackMessage) =>
  GOOGLE_AUTH_ERROR_MESSAGES[code] ||
  fallbackMessage ||
  "Unable to continue with Google. Please try again.";

export const startGoogleAuth = async (next = "/") => {
  try {
    const response = await fetchApi(
      `/api/auth/google/start?next=${encodeURIComponent(next)}`
    );

    if (!response?.success || !response?.data?.url) {
      const code = response?.code || "GOOGLE_AUTH_START_FAILED";
      return {
        success: false,
        code,
        message: getGoogleAuthErrorMessage(code, response?.message),
      };
    }

    return { success: true, url: response.data.url };
  } catch (error) {
    const code = error?.response?.code || "GOOGLE_AUTH_START_FAILED";
    return {
      success: false,
      code,
      message: getGoogleAuthErrorMessage(code, error?.response?.message),
    };
  }
};

export const finishGoogleAuth = async ({ code, next = "/" }) => {
  if (!code) {
    return {
      success: false,
      code: "GOOGLE_AUTH_CODE_MISSING",
      message: getGoogleAuthErrorMessage("GOOGLE_AUTH_CODE_MISSING"),
    };
  }

  try {
    const response = await fetchApi(
      `/api/auth/google/callback?code=${encodeURIComponent(
        code
      )}&next=${encodeURIComponent(next)}`
    );

    if (!response?.success || !response?.data) {
      const responseCode = response?.code || "GOOGLE_AUTH_CALLBACK_FAILED";
      return {
        success: false,
        code: responseCode,
        message: getGoogleAuthErrorMessage(responseCode, response?.message),
      };
    }

    const { session, user } = response.data;
    if (!session?.access_token || !session?.refresh_token || !user) {
      return {
        success: false,
        code: "GOOGLE_AUTH_INVALID_PAYLOAD",
        message: getGoogleAuthErrorMessage("GOOGLE_AUTH_INVALID_PAYLOAD"),
      };
    }

    return { success: true, data: response.data };
  } catch (error) {
    const code = error?.response?.code || "GOOGLE_AUTH_CALLBACK_FAILED";
    return {
      success: false,
      code,
      message: getGoogleAuthErrorMessage(code, error?.response?.message),
    };
  }
};
